import { useState, useEffect } from "react";

interface TerminalSequenceResult {
  inputText: string;
  setInputText: React.Dispatch<React.SetStateAction<string>>;
  isTyping: boolean;
  shouldExecute: boolean;
  setShouldExecute: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useTerminalSequence = (word: string, delay: number = 150): TerminalSequenceResult => {
  const [inputText, setInputText] = useState<string>("");
  const [isTyping, setIsTyping] = useState<boolean>(true);
  const [shouldExecute, setShouldExecute] = useState<boolean>(false);

  useEffect(() => {
    let i = 0;
    let currentText = "";

    const typingInterval = setInterval(() => {
      if (i < word.length) {
        currentText += word[i];
        setInputText(currentText);
        i++;
      } else {
        setIsTyping(false);
        clearInterval(typingInterval);
        setShouldExecute(true);
      }
    }, delay);

    return () => clearInterval(typingInterval);
  }, [word, delay]);

  return {
    inputText,
    setInputText,
    isTyping,
    shouldExecute,
    setShouldExecute
  };
};